var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoistureIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 242.6 355.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.3,2.9C110.6,9.7,0,169.8,0,234.3c0,66.9,54.4,121.3,121.3,121.3s121.3-54.4,121.3-121.3 C242.6,169.8,132,9.7,127.3,2.9C124.6-1,118-1,115.3,2.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoistureIcon);
export default __webpack_public_path__ + "static/media/moisture-icon.cd800131f336e55013df8dcd1df15e3c.svg";
export { ForwardRef as ReactComponent };